import {ColonistMembershipType, StoreExpansionType} from '@colonist/types'

// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing

export enum StoreTransactionType {
    BoughtFromPackPresale = 0,

    GiftFromAdmin = 1,
    DeletedByManager = 2,

    PurchasedCoinFromStripe = 3,
    RefundedCoinToStripe = 4,

    PurchasedItemFromStore = 5, // This is items purchased with coins OR FREE items. Not necessarily a $ transaction
    RefundedItemToStore = 6,

    EarnedFromAchievement = 7,
    EarnedFromTournament = 8,

    PurchasedCoinFromXsolla = 9,
    RefundedCoinToXsolla = 10,

    PurchasedCoinFromDiscordIAP = 11,
    RefundedCoinToDiscordIAP = 12,

    Membership = 13,

    GiftedMembership = 14,
    EarnedByGifting = 15,
    EarnedWithReferralSystem = 16,
    EarnedWithReactivationMessage = 17,
    // PurchasedFromOffer,

    PurchasedCoinFromAppleIAP = 18,
    RefundedCoinToAppleIAP = 19,
}

export const PURCHASE_STORE_TRANSACTION_TYPES = [
    StoreTransactionType.BoughtFromPackPresale,
    StoreTransactionType.PurchasedCoinFromStripe,
    StoreTransactionType.PurchasedCoinFromXsolla,
    StoreTransactionType.PurchasedCoinFromDiscordIAP,
    StoreTransactionType.Membership,
]

export type StoreItemType = StorePresalePackType | StoreExpansionType | StoreMapType | StoreIconType | StorePlayerColor | StoreConsumable | ColonistMembershipType

// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export enum StoreItemCategory {
    PresalePack = 0,
    Expansion = 1,
    Map = 2,
    Icon = 3,
    Color = 4,
    Consumable = 5,
    Membership = 6,
    // GameSkin,
    // Emoji,
    // TopSeller,
}

// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export enum StorePresalePackType {
    SettlerPack = 0,
    ColonistPack = 1,
    FounderPack = 2,
}

// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export enum StoreMapType {
    Earth = 0,
    USA = 1,
    UK = 2,
    Diamond = 3,
    Gear = 4,
    Lakes = 5,
    Pond = 6,
    Twirl = 7,
    Classic4PRandom = 8,
    ShuffleBoard = 9,
    BlackForest = 10,
    Volcano = 11,
    GoldRush = 12,
}

// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
export enum StoreIconType {
    FounderHat = 0,
    ColonistHat = 1,
    SettlerHat = 2,
    ChristmasHat = 3,
    Player = 4,
    PirateShip = 5,
    MedalGold = 6,
    MedalSilver = 7,
    MedalBronze = 8,
    Elephant = 9,
    Avocado = 10,
    Cactus = 11,
    Crown = 12,
    Swords = 13,
    Helmet = 14,
    Snorkel = 15,
    Scarf = 16,
    Tie = 17,
    Worker = 18,
    Sombrero = 19,
    Farmer = 20,
    RobberSanta = 21,
    RobberLunar = 22,
    RobberCupid = 23,
    Mummy = 24,
    Gifter = 25,
}

// Never change the order
// Never delete without migration
// Ok to add values to the end
// Ok to rename
// Run migration after editing
export enum StorePlayerColor {
    Gold = 0,
    Silver = 1,
    Bronze = 2,
    Black = 3,
    Purple = 4,
    MysticBlue = 5,
    White = 6,
    Pink = 7,
}

export enum StoreConsumable {
    UsernameChange = 0,
    PurchaseResourceCardWithColonistCoin = 1,
    PurchaseDevelopmentCardWithColonistCoin = 2,
    PremiumRoom = 3,
}

// export enum StoreOfferType {
//     Expansion5678Players,
// }
